//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import urlencodeFormData from '../../utils/urlencodeFormData';
import addAnyFormFields from '../../utils/addAnyFormFields';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import HintEmail from '../common/hintEmail.vue';
import Phone from '../common/phone.vue';
import PrivacyPolicy from '../common/privacyPolicy.vue';
import Button from '../d0822/fields/button.vue';
import { getGRecaptchaScore } from '@/utils/grecaptcha';
import handleError from '@/utils/handleError';

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    HintEmail,
    Phone,
    PrivacyPolicy,
    Button,
  },
  props: ['slug', 'sourceId', 'scheduleId', 'eventEnded'],
  data() {
    return {
      loading: false,
      name: '',
      phone: '',
      email: '',
      acceptedRules: true,

      namePreloaded: false,
      emailPreloaded: false,
    };
  },
  async mounted() {
    if (process.browser) {
      await this.$nextTick();
      setTimeout(
        async () => await addAnyFormFields.call(this, { ref: this.$refs.form }),
        0,
      );

      if (this.$app?.user?.id) {
        this.name = this.$app.user.name?.trim();
        this.email = this.$app.user.email?.trim();
        this.phone = this.$app.user.profile?.phone || '';

        if (this.name) this.namePreloaded = true;
        if (this.email) this.emailPreloaded = true;
      }
    }
  },
  methods: {
    async onSubmit() {
      if (this.loading) return;

      this.name = this.name.trim();
      this.phone = this.phone.trim();

      this.loading = true;
      const isValid = await this.$refs.form.validate();

      if (!isValid) {
        this.loading = false;
        return;
      }

      try {
        window?.$meter?.event({
          name: 'formSubmit',
          label: 'saleAfterWebinarForm',
        });
      } catch (e) {
        console.error(e);
      }

      const formData = new FormData(this.$refs.form.$el.querySelector('form'));
      formData.append('name', this.name);
      formData.append('phone', this.phone);
      formData.append('email', this.email);
      formData.append('checkbox', this.acceptedRules);

      const grecaptchaScore = await getGRecaptchaScore.bind(this)();
      formData.append('google_score', grecaptchaScore);

      try {
        const response = await this.$axios({
          method: 'post',
          url: this.$app.config.current.leadFormUrl,
          data: urlencodeFormData(formData),
          headers: {
            'Content-Type': `application/x-www-form-urlencoded`,
          },
        });

        this.success = true;

        this.$refs.form.reset();
        this.name = '';
        this.phone = '';
        this.email = '';

        //Обработка для двух возможных эндпоинтов получения контекста
        let context;
        //Версия с диспетчером в AWS
        if (response?.data?.executionArn) {
          context = response.data.executionArn.split(':').at(-1);
        }
        //Версия с старым диспетчером
        else {
          context = response.data.context;
        }

        if (response.status === 200) {
          try {
            window?.$meter?.event({
              name: 'formSuccess',
              label: 'saleAfterWebinarForm',
            });
          } catch (e) {
            console.error(e);
          }
        }

        this.$router.push({
          path: `${this.$route.path}/thankyou`,
          query: { context },
        });
      } catch (e) {
        handleError.bind(this)(e);
      } finally {
        this.loading = false;
      }
    },
  },
};
